import React from "react"
import { withFormik, FormikProps, FormikErrors, Form } from "formik"
import { styled } from "@mui/material"
import { buttonClasses } from "@mui/base/Button"

import i18n from "config/i18n"
import Button from "components/ui/Button"
import { ProductPaymentFormValues } from "types"

interface FormProps {
  initialValues: {
    amount: number
    product: string
    bank_name: string
  }
  title: string
  color: string
  onSubmit: (values: ProductPaymentFormValues) => void
}

type Props = FormikProps<ProductPaymentFormValues> & FormProps

const PaymentForm = ({ title, color, isSubmitting }: Props) => {
  return (
    <Wrapper>
      <Submit type="submit" color={color} disabled={isSubmitting}>
        {title}
      </Submit>
    </Wrapper>
  )
}

const PaymentFormWithFormik = withFormik<FormProps, ProductPaymentFormValues>({
  enableReinitialize: true,
  mapPropsToValues: ({ initialValues }) => initialValues,
  handleSubmit: (values, { props: { onSubmit } }) => onSubmit(values),
  validate: (values: ProductPaymentFormValues) => {
    const errors: FormikErrors<ProductPaymentFormValues> = {}

    if (!values.amount) {
      errors.amount = i18n.t("validation.field.required", {
        field: i18n.t("features.payment.amount"),
      })
    }

    return errors
  },
})(PaymentForm)

export default PaymentFormWithFormik

const Wrapper = styled(Form)`
  margin: 16px 10px;
  max-width: 150px;
`

const Submit = styled(Button)`
  border: none;
  background-color: #f2f2f2;
  border-radius: 21.5px;
  flex-basis: 50%;
  height: 43px;
  width: 150px;

  &.${buttonClasses.root} {
    color: ${({ color }) => color};
  }
`
